import { Phone, MessageCircle, Mail, Clock, MapPin } from "lucide-react";
import { SITE } from "../lib/site";
import { Reveal, MaskedLines } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { useSeo } from "../hooks/useSeo";

export default function Contatti() {
  useSeo({
    title: "Contatti | Rottamazione Auto Roma — Chiama o WhatsApp H24",
    description:
      "Contatta Rottamazione Auto Roma: telefono +39 392 738 8575 e +39 333 338 6960, WhatsApp ed email. Ritiro gratuito h24 a Roma e provincia.",
    path: "/contatti",
  });
  return (
    <div>
      <section className="border-b border-[#232323] pt-40 pb-16">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#8a8a8a]">/ Contatti · {SITE.hours}</p>
          <h1 className="mt-4 font-num uppercase leading-[0.85] tracking-tight text-[13vw] md:text-[9vw]">
            <MaskedLines lines={["Chiamaci", "Adesso"]} />
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <a
            href={`tel:${SITE.phoneTel}`}
            data-testid="contatti-phone-big"
            className="group flex items-center gap-4 border-t border-[#232323] py-8 transition-colors duration-200 hover:text-[#ff3300]"
          >
            <Phone size={36} strokeWidth={1.5} className="shrink-0 text-[#ff3300]" />
            <span className="font-num uppercase leading-none tracking-tight text-[8vw] md:text-[5.5vw]">
              {SITE.phoneDisplay}
            </span>
          </a>
          <a
            href={`tel:${SITE.phone2Tel}`}
            data-testid="contatti-phone-big-2"
            className="group flex items-center gap-4 border-y border-[#232323] py-8 transition-colors duration-200 hover:text-[#ff3300]"
          >
            <Phone size={36} strokeWidth={1.5} className="shrink-0 text-[#ff3300]" />
            <span className="font-num uppercase leading-none tracking-tight text-[8vw] md:text-[5.5vw]">
              {SITE.phone2Display}
            </span>
          </a>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-px border border-[#232323] bg-[#232323] md:grid-cols-2">
          <div className="bg-[#0f0f0f] p-10">
            <MessageCircle size={30} className="text-[#25d366]" />
            <h2 className="mt-6 font-display text-4xl tracking-wide">WhatsApp</h2>
            <p className="mt-2 font-mono text-sm text-[#8a8a8a]">Scrivici una foto del veicolo per un riscontro rapido.</p>
            <div className="mt-6 flex flex-col gap-3">
              <a
                href={SITE.whatsappMsg}
                target="_blank"
                rel="noreferrer"
                data-testid="contatti-whatsapp"
                className="flex items-center justify-between border border-[#232323] px-4 py-3 font-mono text-sm transition-colors duration-150 hover:border-[#25d366] hover:text-[#25d366]"
              >
                {SITE.phoneDisplay}
                <span className="text-[10px] uppercase tracking-[0.16em] text-[#25d366]">Chat →</span>
              </a>
              <a
                href={SITE.whatsapp2Msg}
                target="_blank"
                rel="noreferrer"
                data-testid="contatti-whatsapp-2"
                className="flex items-center justify-between border border-[#232323] px-4 py-3 font-mono text-sm transition-colors duration-150 hover:border-[#25d366] hover:text-[#25d366]"
              >
                {SITE.phone2Display}
                <span className="text-[10px] uppercase tracking-[0.16em] text-[#25d366]">Chat →</span>
              </a>
            </div>
          </div>
          <a
            href={`mailto:${SITE.email}`}
            data-testid="contatti-email"
            className="group bg-[#0f0f0f] p-10 transition-colors duration-200 hover:bg-[#1a1a1a]"
          >
            <Mail size={30} className="text-[#ffd600]" />
            <h2 className="mt-6 font-display text-4xl tracking-wide">Email</h2>
            <p className="mt-2 break-all font-mono text-sm text-[#8a8a8a]">{SITE.email}</p>
            <span className="mt-6 inline-block font-mono text-xs uppercase tracking-[0.16em] text-[#ffd600]">Scrivi una mail →</span>
          </a>
        </div>

        <div className="mt-px grid grid-cols-1 gap-px border-x border-b border-[#232323] bg-[#232323] md:grid-cols-2">
          <div className="flex items-center gap-4 bg-[#0f0f0f] p-8">
            <Clock size={22} className="text-[#f4f4f0]" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">Orari</p>
              <p className="font-display text-2xl tracking-wide">{SITE.hours}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 bg-[#0f0f0f] p-8">
            <MapPin size={22} className="text-[#f4f4f0]" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">Zona</p>
              <p className="font-display text-2xl tracking-wide">{SITE.area}</p>
            </div>
          </div>
        </div>
      </section>

      <Marquee items={["Chiama H24", "Ritiro Gratuito", "WhatsApp", "Roma & Provincia"]} reverse />
    </div>
  );
}
